import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private readonly _httpClient = inject(HttpClient);

  public get(path: string, params: HttpParams | {} = new HttpParams(), context?: HttpContext): Observable<any> {
    return this._httpClient.get(`${environment.apiUrl}${path}`, { params, context });
  }

  public getFile(path: string, params: HttpParams = new HttpParams()): Observable<Blob> {
    return this._httpClient.get(
      `${environment.apiUrl}${path}`,
      {
        params,
        headers: {
          'Accept': '*'
        },
        responseType : 'blob',
      },
    );
  }

  public post(
    path: string,
    body: Object = {},
    params: HttpParams = new HttpParams(),
    responseType?: string,
    observe: 'body' = 'body',
    context?: HttpContext
  ): Observable<any> {
    const options = {
      params: params,
      observe: observe,
      context: context,
      headers: {
        'Content-Type': 'application/json'
      },
    };

    if (responseType) {
      options['responseType'] = responseType;
    }

    return this._httpClient.post(`${environment.apiUrl}${path}`, JSON.stringify(body), options);
  }

  public put(path: string, body = {}, context?: HttpContext): Observable<any> {
    return this._httpClient.put(
      `${environment.apiUrl}${path}`,
      JSON.stringify(body),
      {
        context,
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
  }

  public patch(path: string, body = {}, context?: HttpContext): Observable<any> {
    return this._httpClient.patch(
      `${environment.apiUrl}${path}`,
      JSON.stringify(body),
      {
        context,
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
  }

  public delete(path: string, body = {}, context?: HttpContext): Observable<any> {
    return this._httpClient.delete(`${environment.apiUrl }${path}`, { body, context });
  }
}
